// angular imports
import { WritableSignal, signal } from "@angular/core";

// local imports
import {
  AbstractRoomModel
} from "@app/catalog-common";
import { ProgramModel, ProjectModel, RoomDto } from "@app/catalog";
import { IBreadcrumbItemModel, ListItemFactory } from "@app/shared";

export class RoomModel
  extends AbstractRoomModel
  implements IBreadcrumbItemModel
{

  public type: WritableSignal<string> = signal<string>(null);
  public nsf: WritableSignal<number> = signal<number>(null);

  public program: WritableSignal<ProgramModel>;
  public project: WritableSignal<ProjectModel>;

  constructor() {
    super();
  }

  public static fromDto(dto: RoomDto, isChecked: boolean = false) {
    let room = new RoomModel();

    room.id = dto.id;
    room.thumbnailUrl.set(dto.thumbnailUrl);
    room.name.set(dto.name);
    room.code.set(dto.code);
    room.subCode.set(dto.subcode);
    room.isActive.set(dto.isActive);
    room.isChecked.set(isChecked);

    return room;
  }

  public toListItem = (selected: boolean = false) =>
    ListItemFactory.create<RoomModel>(this.name, this.id, this, selected);

  public toListItem$ = (selected: WritableSignal<boolean>) =>
    ListItemFactory.create$<RoomModel>(this.name, this.id, this, selected);
}
